import React, { Fragment } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Toast from "../components/Toast";


class Index extends React.Component {

  renderToast(){
    let {showToast, error, message} = this.props; 
    return <Toast show={showToast} message={message} success={!error}/>
  }  

  render() {
    return (
      <Fragment>
        {this.renderToast()}
        
        {this.props.children}
      </Fragment>
    );
  }
}

function mapStateToProps(store) {
  return {
    showToast: store.global.showToast,
    error: store.global.error,
    message: store.global.message
  };
}

export default withRouter(connect(mapStateToProps)(Index));
